import React from "react";
import { useTranslation } from "react-i18next";
import NavDropdown from "react-bootstrap/NavDropdown";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <NavDropdown title="🌐 Language" id="language-selector">
      <NavDropdown.Item onClick={() => handleLanguageChange("es")}>
        Español
      </NavDropdown.Item>
      <NavDropdown.Item onClick={() => handleLanguageChange("en")}>
        English
      </NavDropdown.Item>
      <NavDropdown.Item onClick={() => handleLanguageChange("pt")}>
        Português
      </NavDropdown.Item>
    </NavDropdown>
  );
};

export default LanguageSelector;